import { PersonsComponent } from "./persons.component";
import { PersonOverviewComponent } from "./person-overview.component";
import { EditPersonDetailsComponent } from "./details/person.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";

import { personsState, personState, newPersonState, editPersonState } from "./persons.states";
import { personWorkplacesDetailsState, personWorkplacesEditState, personWorkplacesNewState } from "./workplaces/person.workplaces.states";
import { personJobTitlesDetailsState, personJobTitlesEditState, personJobTitlesNewState } from "./jobtitles/person.jobtitles.states";
import { personRolesDetailsState, personRolesEditState, personRolesNewState } from "./roles/person.roles.states";
import { personCompetencesDetailsState, personCompetencesEditState, personCompetencesNewState } from "./competences/person.competences.states";

import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import { PersonComponent } from "./details/person.component";
import { PersonDetailsComponent } from "./details/person.details.component";

import { PersonWorkplacesComponent } from "./workplaces/person.workplaces.component";
import { PersonWorkplaceComponent } from "./workplaces/person.workplace.component";
import { PersonWorkplaceEditComponent } from "./workplaces/person.workplace.edit.component";

import { PersonJobTitlesComponent } from "./jobtitles/person.jobtitles.component";
import { PersonJobTitleComponent } from "./jobtitles/person.jobtitle.component";
import { PersonJobTitleEditComponent } from "./jobtitles/person.jobtitle.edit.component";

import { PersonRolesComponent } from "./roles/person.roles.component";
import { PersonRoleComponent } from "./roles/person.role.component";
import { PersonRoleEditComponent } from "./roles/person.role.edit.component";

import { PersonCompetencesComponent } from "./competences/person.competences.component";
import { PersonCompetenceComponent } from "./competences/person.competence.component";
import { PersonCompetenceEditComponent } from "./competences/person.competence.edit.component";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";


let STATES = [
    personsState,
    personState,
    newPersonState, 
    editPersonState,
    personWorkplacesDetailsState,
    personWorkplacesEditState,
    personWorkplacesNewState,

    personJobTitlesDetailsState,
    personJobTitlesEditState,
    personJobTitlesNewState,

    personRolesDetailsState,
    personRolesEditState,
    personRolesNewState,

    personCompetencesDetailsState,
    personCompetencesEditState,
    personCompetencesNewState
];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";
import { MatDatepickerModule } from "@angular/material";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        MatDatepickerModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    declarations: [
        PersonsComponent,
        PersonOverviewComponent,
        EditPersonDetailsComponent,
        PersonComponent,
        PersonDetailsComponent,
        PersonWorkplacesComponent,
        PersonWorkplaceEditComponent,
        PersonWorkplaceComponent,
        PersonJobTitlesComponent,
        PersonJobTitleComponent,
        PersonJobTitleEditComponent,
        PersonRolesComponent,
        PersonRoleComponent,
        PersonRoleEditComponent,
        PersonCompetencesComponent,
        PersonCompetenceComponent,
        PersonCompetenceEditComponent
    ],
    entryComponents: [ConfirmDialog],
    providers: [
    ],
})
export class PersonComponentsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/persons.module.ts